import React from 'react';
import { Typography, Link } from '@material-ui/core';
import type {FC} from 'react';
import {useStyles} from './TextBlock.styles'

export const TextBlock: FC = () => {
  const classes = useStyles();
  const linkPrivacyStatement = "https://www.basf.com/global/en/legal/data-protection.html";
  return <>
    <Typography variant='h3' className={classes.title}>We Value Your Privacy! </Typography>
    <Typography variant="body1" component="p" className={classes.body}>
      By clicking “Accept All Cookies”, you agree to the storing of cookies on your device to analyze site usage.
      &nbsp;<Link className={classes.linkPrivacyStatement} href={linkPrivacyStatement} target="_blank">Privacy Statement</Link>
    </Typography>
  </>
}